"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = loadOptionsSuccess;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _find = _interopRequireDefault(require("lodash/find"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _choiceFunctions = _interopRequireDefault(require("./choiceFunctions"));
var _headRailWidthDistributor = _interopRequireDefault(require("../../services/blinds/headRailWidthDistributor"));
var _settings = require("../../settings");
var _presentations = require("../../utils/presentations");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable lodash/prefer-lodash-method */
function getDefaultChoiceId(option, choices) {
  var presentationName = option.presentationName.toLowerCase();
  var defaultChoice = option.choices.find(function (cid) {
    return choices[cid].isDefault;
  });
  if (defaultChoice) {
    return defaultChoice;
  }
  if (presentationName === 'height' || presentationName === 'width' || (0, _presentations.isPresentationSelectingFirstChoiceAsDefault)(presentationName)) {
    return option.choices[0];
  }
  return undefined;
}
var getDefaultChoiceValue = function getDefaultChoiceValue(choice, option) {
  var _getSettings = (0, _settings.getSettings)(),
    getDefault = _getSettings.getDefaultChoiceValue;
  var optionPresentation = option.presentationName.toLowerCase();
  var match = (0, _find["default"])(getDefault, function (opt) {
    return opt.predicate(choice, option);
  });
  return match ? match.getValue(choice, option) : (0, _choiceFunctions["default"])(choice, optionPresentation);
};
function trySelectingPreconfig(preconfig, option, choices) {
  if (!preconfig) {
    return false;
  }
  var preselectedChoice = preconfig && choices[preconfig.choiceId];
  if (!preselectedChoice) {
    console.warn("CONFIGURATOR: Preconfiguration contains a choiceId of ".concat(preconfig.choiceId, " but no choice with this id was found for this product."));
    return false;
  }

  // eslint-disable-next-line no-param-reassign
  option.choices.forEach(function (choiceId) {
    choices[choiceId].isSelected = false;
  });
  var choice = preselectedChoice;
  choice.isSelected = true;
  choice.value = preconfig.choiceValue || choice.value;
  choice.value = (0, _clamp["default"])(choice.value, choice.minValue, choice.maxValue) || choice.value;
  return true;
}
function selectDefaultIfNoneSelected(option, choices) {
  var selectedChoice = option.choices.find(function (cid) {
    return choices[cid].isSelected;
  });
  if (selectedChoice) {
    return;
  }
  var defaultChoiceId = getDefaultChoiceId(option, choices);
  if (defaultChoiceId) {
    // eslint-disable-next-line no-param-reassign
    choices[defaultChoiceId].isSelected = true;
  }
}
function loadOptionsSuccess(state, _ref) {
  var normalizedOptions = _ref.options,
    normalizedChoices = _ref.choices,
    preselectedChoices = _ref.preselectedChoices,
    clearState = _ref.clearState;
  var nextStateStart = clearState ? {} : _objectSpread({}, state);
  var choices = (0, _transform["default"])(normalizedChoices, function (obj, choice, choiceId) {
    var option = normalizedOptions[choice.optionId];

    /* eslint-disable no-param-reassign */
    if (choice.isAvailable !== undefined) {
      obj[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        value: choice.value || getDefaultChoiceValue(choice, option),
        fillDate: choice.fillDate && new Date(choice.fillDate)
      });
    } else {
      obj[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        value: choice.value || getDefaultChoiceValue(choice, option),
        isAvailable: true,
        fillDate: choice.fillDate && new Date(choice.fillDate)
      });
    }
  }, nextStateStart);
  /* eslint-enable no-param-reassign */

  // set defaults
  (0, _forEach["default"])(normalizedOptions, function (option, optionId) {
    // check preconfig first, then defaults
    var preconfig = preselectedChoices[optionId];
    var preselected = trySelectingPreconfig(preconfig, option, choices);
    if (preselected) {
      return;
    }
    selectDefaultIfNoneSelected(option, choices);
  });
  (0, _headRailWidthDistributor["default"])(normalizedOptions, choices);
  return choices;
}
//# sourceMappingURL=loadOptionsSuccess.js.map